export function normalizeMtAccounts(value: unknown): string[] {
  if (!Array.isArray(value)) return [];

  const accounts = value
    .filter((account): account is string => typeof account === 'string')
    .map((account) => account.trim())
    .filter((account) => /^\d+$/.test(account) && Number.isSafeInteger(Number(account)) && Number(account) > 0);

  return [...new Set(accounts)];
}
